import * as React from "react";

const TalentMobilityIcon = ({ size = 33, ...props }) => (
  <svg
    data-stroke="true"
    width={size}
    height={size}
    viewBox="1.2 1.2 22.6 20.4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Briefcase handle */}
    <path
      d="M5.8 7.1V5.8C5.8 4.75 6.65 3.9 7.7 3.9H12.6C13.65 3.9 14.5 4.75 14.5 5.8V7.1"
      stroke="currentColor"
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.6 7.1V5.95C7.6 5.55 7.92 5.23 8.32 5.23H11.98C12.38 5.23 12.7 5.55 12.7 5.95V7.1"
      stroke="currentColor"
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Briefcase body */}
    <path
      d="M3.4 7.1H16.7C17.47 7.1 18.1 7.73 18.1 8.5V13.8"
      stroke="currentColor"
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.4 7.1C2.63 7.1 2 7.73 2 8.5V15.9C2 16.67 2.63 17.3 3.4 17.3H8.7"
      stroke="currentColor"
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Briefcase flap */}
    <path
      d="M2.15 10.2L10.05 12.15L18 10.2"
      stroke="currentColor"
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Briefcase clasp */}
    <path
      d="M8.85 11.85V13.1C8.85 13.78 9.39 14.32 10.07 14.32C10.75 14.32 11.29 13.78 11.29 13.1V11.85"
      stroke="currentColor"
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Growth arrow */}
    <path
      d="M4.9 22.6L10.2 17.3L12.35 19.45L18.95 12.85"
      stroke="currentColor"
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Arrow head */}
    <path
      d="M16.9 12.85H19.05V15"
      stroke="currentColor"
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Star */}
    <path
      d="M21.55 3.35L22.12 4.52L23.4 4.71L22.47 5.61L22.69 6.88L21.55 6.28L20.41 6.88L20.63 5.61L19.7 4.71L20.98 4.52L21.55 3.35Z"
      stroke="currentColor"
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Three bars */}
    <path d="M20.15 8.35V9.55" stroke="currentColor" strokeWidth="1.15" strokeLinecap="round" />
    <path d="M21.55 7.95V9.55" stroke="currentColor" strokeWidth="1.15" strokeLinecap="round" />
    <path d="M22.95 8.35V9.55" stroke="currentColor" strokeWidth="1.15" strokeLinecap="round" />
  </svg>
);

export default TalentMobilityIcon;
